import { createIcon } from '@chakra-ui/react';

export const ChevronDown = createIcon({
  displayName: 'Chevron Down',
  viewBox: '0 0 64 64',
  path: (
    <g id="Chevron" transform="translate(0 64) rotate(-90)">
      <rect id="bg" width="64" height="64" fill="none" />
      <path
        id="Chevron_-_L"
        data-name="Chevron - L"
        d="M48.418,61.6l-29.4-29.315,29.4-29.5A1.509,1.509,0,1,0,46.285.653l-30.5,30.532a1.519,1.519,0,0,0,0,2.143l30.5,30.412a1.529,1.529,0,0,0,1.066.433,1.459,1.459,0,0,0,1.066-.443,1.5,1.5,0,0,0,0-2.133Z"
        transform="translate(-0.34 -0.172)"
        fill="currentColor"
      />
    </g>
  ),
});
